import { render, staticRenderFns } from "./operatingIncome.vue?vue&type=template&id=8c42010e&"
import script from "./operatingIncome.vue?vue&type=script&lang=js&"
export * from "./operatingIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports